import type { FC } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const FeatureTitle = styled.p(({ theme }) => ({
  ...theme.variants.body2.medium,
  marginBottom: theme.spacings.xxxSmall,
}))

const FeatureSection = styled.div(({ theme }) => ({
  marginBottom: theme.spacings.large,
}))

interface ProductFeaturesProps {
  storageGuideForConsumer: string | null
  userGuideForConsumer: string | null
}

export const ProductFeatures: FC<ProductFeaturesProps> = ({
  storageGuideForConsumer,
  userGuideForConsumer,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {storageGuideForConsumer && (
        <FeatureSection data-test-id="product-features-info-storage-guide">
          <FeatureTitle>{t('Product features info storage guide')}</FeatureTitle>
          <p>{storageGuideForConsumer}</p>
        </FeatureSection>
      )}

      {userGuideForConsumer && (
        <FeatureSection data-test-id="product-features-info-user-guide">
          <FeatureTitle>{t('Product features info user guide')}</FeatureTitle>
          <p>{userGuideForConsumer}</p>
        </FeatureSection>
      )}
    </>
  )
}
